import KeyInformation from '@/pages/CompanyReport/components/Introduction/components/KeyInformation';
import { useNonBankMetrics } from '@/pages/CompanyReport/components/Health/hooks';
import { Heading } from '@simplywallst/ui-core';
import { useHealthTranslations } from '../../../../hooks/useHealthTranslations';
import { useMemo } from 'react';
import type { HeadingElements } from '@/utilities/heading';

type Props = {
  canonicalURL: string;
  titleElement?: HeadingElements;
};

function getKeyFromKeyMetric(keyMetric: string) {
  switch (keyMetric) {
    case 'Debt to equity ratio':
      return 'keyInfo.debtToEquityRatio';
    case 'Debt':
      return 'keyInfo.debt';
    case 'Interest coverage ratio':
      return 'keyInfo.metric.interestCoverageRatio';
    case 'Cash':
      return 'keyInfo.metric.cash';
    case 'Equity':
      return 'keyInfo.metric.equity';
    case 'Total liabilities':
      return 'keyInfo.metric.totalLiabilities';
    case 'Total assets':
      return 'keyInfo.metric.totalAssets';
  }
}
export const KeyInformationNonBank = ({
  canonicalURL,
  titleElement = 'h3',
}: Props) => {
  const { keyMetrics, metrics } = useNonBankMetrics(canonicalURL);
  const t = useHealthTranslations();

  const translatedKeyMetrics = useMemo(() => {
    return keyMetrics.map((keyMetric) => {
      const translatedTitle = getKeyFromKeyMetric(keyMetric.title);
      return {
        ...keyMetric,
        title: translatedTitle ? t(translatedTitle) : keyMetric.title,
      };
    }) as typeof keyMetrics; // need to cast here because the map function is not smart enough to know that the return type is the same as the input type
  }, [keyMetrics, t]);

  const translatedMetric = useMemo(() => {
    return metrics.map((metric) => {
      const translatedTitle = getKeyFromKeyMetric(metric.title);
      return {
        ...metric,
        title: translatedTitle ? t(translatedTitle) : metric.title,
      };
    });
  }, [metrics, t]);
  return (
    <KeyInformation
      direction="row"
      keyMetrics={translatedKeyMetrics}
      metrics={translatedMetric}
      heading={
        <Heading as={titleElement} typography="small">
          {t('keyInformation')}
        </Heading>
      }
    />
  );
};
